import { keyBy } from "lodash";

import { KeyMap } from "./interface";

/**
 * Creates array containing consecutive numbers.
 * @param {number} arrayLength Array length.
 */
export const iterableNumericArray = (arrayLength: number): number[] => Array.from(Array(arrayLength).keys());

/**
 * Finds matching element in an array based on object containing set of criteria.
 * To be used when filters are dynamic.
 * @param {any[]} arr Array to filter.
 * @param {{ [key: string]: any }} filters containing set of filters to be applied in form of [{ filterKey: filterValue }, [...anotherFilter]]
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const findByFilterObject = (arr: any[], filters: { [key: string]: any }) => {
  const filterKeys = Object.keys(filters);
  return arr.find(eachObj =>
    filterKeys.every(eachKey => (!filters[eachKey].length ? true : filters[eachKey].includes(eachObj[eachKey])))
  );
};

/**
 * Determines if arrays are equal regardless of elements sequence.
 * @param arrA First array to compare.
 * @param arrB Second array to compare.
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const areSimilar = (arrA: any[], arrB: any[]): boolean => {
  if (!Array.isArray(arrA) || !Array.isArray(arrB)) {
    return false;
  }

  if (arrA.length !== arrB.length) {
    return false;
  }

  const sortedA = [...arrA].sort();
  const sortedB = [...arrB].sort();
  return sortedA.every((value, index) => value === sortedB[index]);
};

/**
 * Converts an array to a key map using passed key.
 * @param arr Array to convert.
 * @param key Kay name for property that should be trated as key in returned key map.
 */
export function toKeyMap<T extends object>(arr: T[], key: string): KeyMap<T> {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const anyIsMissingKeyProperty = arr.some(item => !(key in item) || item[key] === undefined);
  if (anyIsMissingKeyProperty) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'KeyMap<T>'.
    return null;
  }

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return keyBy<T>(arr, v => v[key]);
}

/**
 * Returns an array without duplicate entries.
 * @param arr Array to remove duplicates from.
 */
export function removeDuplicates<T extends string | number | boolean>(arr: T[]): T[] {
  return [...new Set(arr)];
}

/**
 * Joins array using ',' and using separator for last item.
 * @param arr Array for strings to join together
 * @param separator string to be placed with last item
 */
export function formattedJoinArray<T extends string[]>(arr: T, separator = "and"): string {
  if (arr.length === 1) {
    return arr[0];
  }

  if (arr.length === 2) {
    return arr.join(` ${separator} `);
  }

  return `${arr.slice(0, -1).join(", ")} ${separator} ${arr.slice(-1)}`;
}

/**
 * Selects a random index given weights.
 * @param weights - A list of numbers representing weights.
 * @returns {number} An index in the list, selected based on the given weights.
 * Original source: btmills/weighted-random (github)
 */
export function weightedRandomIndex(weights: number[]): number {
  const totalWeight = weights.reduce((previousValue, weight) => previousValue + weight);
  let random = Math.random() * totalWeight;

  for (let i = 0; i < weights.length; i += 1) {
    if (random < weights[i]) {
      return i;
    }

    random -= weights[i];
  }

  return -1;
}
